import React, { Component } from 'react';
import { connect } from "react-redux";
import {
  WithStyles,
  Theme,
  createStyles,
  Grid,
  Typography,
  Button,
  withStyles,
  Menu,
  MenuItem,
  ClickAwayListener,
} from '@material-ui/core';
import {
  MoreVert as MoreIcon,
  NavigateBeforeOutlined as BackIcon
} from '@material-ui/icons';
import { MyPATDialog, MyPATIconButton, MyPATTextField } from '../../common';
import { Link } from 'react-router-dom';
import { GOAL_ACTION_TYPE_CONST } from '../container/GoalManagementContainer';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { showMsg } from "../actions/goalManagementActions"
import goalManagementService from "../services/goalManagementService";
import axios from '../../../services/axios';
import { debounce } from '../../../utils';

const styles = (theme: Theme) => createStyles({
  btnAddNewGoal: {
    marginRight: theme.spacing.unit * 2,
    padding: 20,
    fontWeight: 600
  },
  title: {
    fontWeight:600,
    fontSize:'2.125rem',
    lineHeight:'18px',
    display: "flex",
    color: "rgb(51 51 51)",
    whiteSpace: "nowrap",
  },
  actionSetting: {
    display: "inline-block",
    position: "relative",
  },
  fontWeight600: {
    fontWeight: 600
  },
  fontSizeLg: {
    fontSize: '1.5rem'
  },
  moreMenu: {
    top: "100%",
    right:0,
    border: "solid 0.5px #9999",
    position: "absolute",
    boxShadow: "0px 5px 2px rgba(0, 0, 0, 0.05)",
    marginTop:12,
    background: "#fff",
    borderRadius:4,
    zIndex:1,
    minHeight:64,
   '& ul': {
      padding: 0,
      margin: '10px 0px'
    },
    '&::before': {
      position: 'absolute',
        content: '" "',
        top: -8,
        right: 12,
        width: 14,
        height: 14,
        background: 'rgb(255 255 255)',
        borderRight: '0.5px solid #9999',
        borderTop: '0.5px solid #9999',
        transform: 'rotate(-45deg)',
        webkitTransform: 'rotate(-45deg)'
    },
    '& li': {
      color: "rgba(102, 102, 102, 1)",
      width: "100%",
      height:32,
      fontSize:14,
      listStyle: "none",
      paddingTop:6,
      whiteSpace: "nowrap",
      paddingLeft:12,
      paddingRight:30,
      paddingBottom:4,
      '& > svg': {
        marginRight: theme.spacing.unit,
        fontSize: '1rem',
      },
      '&:hover': {
        background: 'rgba(149, 149, 149, 0.05)',
        cursor: 'pointer'
      }
    }
  },
  noDecorationLink: {
		textDecoration: 'none',
  },
  backIconRoot: {
		fill: theme.palette.text.secondary,
		fontSize: 24,
		opacity: 0.5,
		marginBottom: 3,
  },
  toolTipArrow: {
    '&:hover:after': {
        content: '""',
        position: 'absolute',
        left: '50%',
        marginLeft: -5,
        bottom: -8,
        width: 0,
        height: 0,
        borderLeft: '5px solid rgba(0, 0, 0, 0)',
        borderRight: '5px solid rgba(0, 0, 0, 0)',
        borderBottom: '8px solid rgb(0, 0, 0)'
    }
},
tooltipDetails: {
  position: 'absolute',
  marginTop: 36,
  zIndex: 999999
},
paper: {
  width:560,
    margin: "-10px -9px -12px",
    padding: "18px 20px 18px",
    borderRadius:4,
    backgroundColor: "hsl(0deg 0% 100%)",
  '& .label':{
    marginBottom:10,
    fontSize:14,
    fontWeight:600,
  },
'& .footer':{
  background:'#fff'
},
},

primaryBtn: {
  margin: "0px -12px !important",
  minWidth: 100,
  fontSize:14,
}
});

interface GoalManagementHeaderProps extends WithStyles<typeof styles> {
  addGoalClickHandler: (id: string, name: string) => void,
  redirectToDeletedGoals:any,
  handleActionType: (type : string) => void,
  careerOptionClickHandler: () => void,
  addGoalCategory:boolean,
  loggedInUserData: any,
  showLicenseExpiredDialog: any,
  isPostExpiryDays: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any;
  showMsg: Function;
}

interface GoalManagementHeaderState {
  moreMenuAnchor: boolean,
  showTooltip: boolean,
  addGoalCategory:boolean,
  newCategory:string
}

class GoalManagementHeader extends Component<GoalManagementHeaderProps, GoalManagementHeaderState> {
  divRef: HTMLDivElement | null = null;
  constructor(props: GoalManagementHeaderProps) {
    super(props);
    this.state = {
      moreMenuAnchor: false,
      showTooltip: false,
      addGoalCategory:false,
      newCategory:'',
    };
    this.openCategoryDialog = this.openCategoryDialog.bind(this);
    this.handleMoreMenuOpen = debounce(this.handleMoreMenuOpen, 100);
    this.handleMoreMenuClose = this.handleMoreMenuClose.bind(this);
  }

  componentDidMount(){
     this.props.setLoggedInUser();
  }

  handleMoreMenuOpen = (evt: any) => {
    const { moreMenuAnchor } = this.state;
    this.setState({ moreMenuAnchor: !moreMenuAnchor });
  }
  handleMoreMenuClose = () => this.setState({ moreMenuAnchor: false });

  handleAddGoalClick = (e : any,name : string) => {
    
    if(this.props.isPostExpiryDays){
      this.props.toggleLicenseExpiredDialog(true);
    } else {
      this.props.addGoalClickHandler(e,name);
    }
  }

  handleHover() {
		this.setState({
            showTooltip: !this.state.showTooltip
        })
	}
  handleCategoryNameChange=(e:any)=>{
this.setState({
  newCategory:e.target.value
})
  }
  handleCloseCategoryDialog=()=>{
this.setState({
  addGoalCategory:false,
  moreMenuAnchor:false
})
  }
  openCategoryDialog(){
    if(this.state.newCategory === ""){
  this.setState({
     addGoalCategory:true,
     moreMenuAnchor:false
   })
  }else{
    this.setState({
      newCategory:'',
      addGoalCategory:true
    })
  }
  }
  renderDialog=()=>{
const {addGoalCategory,newCategory } = this.state
const {classes } = this.props
    return(
      <>

      <MyPATDialog
           dialogOpen={addGoalCategory}
           dialogHeading={
            <Typography
            align="center"
            className={[classes.fontWeight600, classes.fontSizeLg].join(
              " "
            )}
          >
            Add Category
          </Typography>
           }
           dialogHasActions={true}
           onDialogClose={this.handleCloseCategoryDialog}
           isCustomBackground={true}
           isFooterWhite={true}
           customDialogActions={
           <>
           <Grid  justify="flex-end" container alignItems="flex-end">
             <Grid item>
               <Button onClick={()=>this.addNewCategory(newCategory)} 
               classes={{root: classes.primaryBtn}}
                variant="contained"
                   color="primary"
                   disabled={this.state.newCategory===''}
                 >Add</Button>
               </Grid>
               </Grid>
           </>
           }>
            <Grid container justify="center" className={classes.paper}>
             <Grid item xs={12}>
             <Typography className='label'>
               Category Name
             </Typography>
             </Grid>
             <Grid item xs={12}> 
             <MyPATTextField
              placeholder="Add Category Name"
              name="Add Category Name"
              value={newCategory}
              onChange={this.handleCategoryNameChange.bind(this)}
              required
              fullWidthControl
             />
             </Grid>
           </Grid>
          
         </MyPATDialog>
    
    </>
    )
  }
  addNewCategory=(newCategory:string)=>{
    if(newCategory.length >=3){
    goalManagementService.addNewGoalCategory({name:newCategory});
    this.setState({
      addGoalCategory:false
    })
  }else{
    this.props.showMsg("At least 3 character required", "error")
  }
  }
  render() {
    
    const {
      classes,
      addGoalClickHandler,
      careerOptionClickHandler,
    } = this.props;
    const {addGoalCategory, moreMenuAnchor, showTooltip } = this.state;
    let _length:number = (window.location.href.split("?")).length
    return (
      <Grid container spacing={8} alignItems="center" justify="space-between">
        <Grid item xs="auto">
            {
              _length > 1 ?
                <Link to="/course" className={classes.noDecorationLink}>
                <Typography color="textPrimary" variant="subtitle1">
                  <BackIcon classes={{ root: classes.backIconRoot }} />
                    <strong>Back to Course</strong>
                      </Typography>
              </Link>
              :
              <Typography variant="h6" className={classes.title}>Goal Management
              <CustomInfoIcon
												infoDialogContentType="Goal Management"
												isInfoIcon={true}
												isRightArrow={false}
												isCenterArrow={true}
												knowMoreAbout={false}
												dialogTitle="Goal Management"
												imageURL="/assets/svg/infoIcon/goalManagement/goals.svg"
												dialogPara="All the goals created for the organization/institute are visible along with their target year(s) and options to create and edit the goal and its versions."
												details="Click to know more"
												toolTipDirection="top" />
              </Typography>
            }
					
            
        </Grid>

        <Grid item xs="auto">
          <Button
            variant="contained"
            color="primary"
            className={classes.btnAddNewGoal}
            onClick={(e: any) => this.handleAddGoalClick(e, '')}
          >
            Add Goal
          </Button>
          <Grid className={classes.actionSetting}>
          <MyPATIconButton
            buttonVariant="bordered"
            aria-haspopup="true"
            onClick={this.handleMoreMenuOpen}
         //   onBlur={this.handleMoreMenuOpen.bind(this)}
            onMouseOver={this.handleHover.bind(this)} 
            onMouseOut={this.handleHover.bind(this)} 
            className={classes.toolTipArrow} 
            anchorEL={true} 
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}           
          >
            <MoreIcon />
          </MyPATIconButton>
          <span className={classes.tooltipDetails}>
                {
					  showTooltip && 
					<>
                    <CustomInfoIcon 
                    isInfoIcon={false} 
                    isCenterArrow={false}
                    isRightArrow={showTooltip} 
                    details="Download the unique code list of syllabus items"
                    toolTipDirection="right"/>
                      </>
                    }
                    
                </span>
          {moreMenuAnchor &&
          <ClickAwayListener onClickAway={this.handleMoreMenuOpen}>      
               <Grid            
            // onClose={this.handleMoreMenuClose.bind(this)}
            className={classes.moreMenu}
          >
            {/* <MenuItem onClick={redirectToDeletedGoals}>
              Deleted Goals
            </MenuItem> */} 
            <ul>
            <li onClick={this.openCategoryDialog}>
              Goal Category
            </li>
            {/* <MenuItem onClick={()=>{
              //@ts-ignore
              this.props.history.push('/goal-management/deleted')
            }}>
              Archived Goals
            </MenuItem> */}
            <li onClick={() => {
              if(this.props.isPostExpiryDays){
                this.props.toggleLicenseExpiredDialog(true)
              } else {
                careerOptionClickHandler();
                this.handleMoreMenuOpen;
              }
            }}>
              Career Option
            </li>
          </ul>
          </Grid>
          </ClickAwayListener>
          }
          </Grid>
        </Grid>
        {addGoalCategory &&
         this.renderDialog()}
      </Grid>
    );
  }
}

const mapStateToProps = (state: any) => ({
  loggedInUserData:
    state.loginData.userData &&
    state.loginData.userData.loggedInUserData,
  showLicenseExpiredDialog:
    state.loginData.userData &&
    state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:
    state.loginData.userData &&
    state.loginData.userData.isPostExpiryDays,
});

const mapDispatchToProps = {
  toggleLicenseExpiredDialog,
  setLoggedInUser,
  showMsg
};

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(GoalManagementHeader));